<template>
    <div>
        <topBar :title="$t('newSurvey.statistic')" />
    <div class="commonContainer">
        <div class="filterConditionContainer">
            <el-card class="box-card">
                <div class="filterCondition">
                    <div class="searchIcon">
                        <i class="el-icon-search"></i>
                    </div>
                    <el-form :inline="true" :model="filterForm" class="filterForm" label-width="">
                        <el-form-item label="报告日期"> 
                          <el-date-picker v-model="dateFilter" value-format="yyyy-MM-dd" style=""
                                type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" />
                            </el-form-item>
                    </el-form>
                    <el-row type="flex" class="row-bg" justify="space-between">
                        <el-col :span="8">
                            <div class="filterBtns">
                                <el-button type="primary" @click="onSearch()">{{ $t('search') }}</el-button>
                                <el-button type="primary" @click="onReset">{{ $t('reset') }}</el-button>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </el-card>
        </div>
        <div class="tableContainer" style="margin-top: 20px !important;">
            <div class="inner-wrapper" v-loading="loading">
                <el-card class="box-card questionnaire-count" >
                    <div class="title">问卷数</div>
                    <div class="box-inner">{{ searchResult.questionnaireCount }}
                        <div class="box-label">问卷数</div>
                    </div>
                    <el-button class="box-inner-btn" type="text" @click="toAllStatistic">查看全部</el-button>
                </el-card>
                <el-card class="box-card submit-count">
                    <div class="title">{{showDoorCount?"门店提交数":"提交数"}}</div>
                    <div v-if = "!showDoorCount&&searchResult.showScore">
                      <el-row>
                        <el-col :span="12">
                          <div class="box-inner">{{ searchResult.submitCount }}
                        <div class="box-label">提交数</div>
                    </div>
                        </el-col>
                        <el-col :span="12">
                          <div class="box-inner">{{ searchResult.score }}
                        <div class="box-label">问卷分数</div>
                    </div>
                        </el-col>
                      </el-row>
                    </div>
                    <div v-if = "!showDoorCount&&!searchResult.showScore">
                      <el-row>
                        <el-col :span="24">
                          <div class="box-inner">{{ searchResult.submitCount }}
                        <div class="box-label">提交数</div>
                    </div>
                        </el-col>
                      </el-row>
                    </div>
                    <div v-if="showDoorCount&&searchResult.showScore">
                      <el-row>
                        <el-col :span="8">
                        <div class="box-inner" >{{ searchResult.doorCount }}
                        <div class="box-label">门店数</div>
                    </div>
                        </el-col>
                        <el-col :span="8">
                          <div class="box-inner">{{ searchResult.submitCount }}
                        <div class="box-label">提交数</div>
                    </div>
                        </el-col>
                        <el-col :span="8" v-if="searchResult.showScore">
                          <div class="box-inner">{{ searchResult.score }}
                        <div class="box-label">问卷分数</div>
                    </div>
                        </el-col>
                      </el-row>
                    </div>
                    <div v-if="showDoorCount&&!searchResult.showScore">
                      <el-row>
                        <el-col :span="12">
                        <div class="box-inner" >{{ searchResult.doorCount }}
                        <div class="box-label">门店数</div>
                    </div>
                        </el-col>
                        <el-col :span="12">
                          <div class="box-inner">{{ searchResult.submitCount }}
                        <div class="box-label">提交数</div>
                    </div>
                        </el-col>
                      </el-row>
                    </div>
                </el-card>
                <el-card class="box-card region-count">
                    <div class="title">区域提交数</div>
                    <div class="box-inner box-container">
                        <div class="box-item item2" v-for="item in searchResult.regions" :key="item.no" v-show="item.label">
                            <el-progress type="circle" :percentage="item.count / searchResult.submitCount * 100"
                                :show-text="false" :width="120" :stroke-width="15" color="#67c23a" 
                                stroke-linecap="butt"></el-progress>
                            <div class="box-label2">{{ item.count }}</div>
                            <div class="box-label">{{ item.label }}</div>
                            <el-button round @click="showDialog(item.no, item.count, item.label)">查看区域客户统计</el-button>
                        </div>
                    </div>
                </el-card>
                <el-card class="box-card reseller-count" v-if="isAdmin||canDownload">
                    <div class="title">客户提交数</div>
                    <div class="box-inner box-container">
                        <div class="box-item item5" v-for="item in searchResult.resellers" :key="item.no">
                            <el-progress type="circle" :percentage="item.count / searchResult.submitCount * 100"
                                :show-text="false" :width="100" :stroke-width="15" color="#67c23a"
                                stroke-linecap="butt"></el-progress>
                            <div class="box-label5">{{ item.count }}</div>
                            <div class="box-label">{{ item.label }}</div>
                        </div>
                    </div>
                </el-card>
            </div>
        </div>
        <el-dialog :title="clickLabel + '-客户提交数'" :visible.sync="showFlag" width="50%" center>
            <div class="box-card reseller-count">
                <div class="title"></div>
                <div class="box-inner box-container">
                    <div class="box-item item5" v-for="item in subReseller" :key="item.no">
                        <el-progress type="circle" :percentage="item.count / clickSum * 100" :show-text="false"
                            :width="100" :stroke-width="15" stroke-linecap="butt" color="#67c23a"></el-progress>
                        <div class="box-label5">{{ item.count }}</div>
                        <div class="box-label">{{ item.label }}</div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
    </div>
           
</template>
<script>
import TopBar from "../components/TopBar.vue";
export default {
  name: "StatisticReport",
  components: {
    topBar: TopBar
  },
  data() {
    return {
      dateFilter: [],
      filterForm: {},
      searchResult: {
        questionnaireCount: 0,
        submitCount: 0,
        doorCount: 0,
        showScore: false,
        score: 0,
        regions: [],
        resellers: []
      }, // 表格数据
      subReseller: [],
      total: 0,
      current: 1, // 当前页码
      showFlag: false,
      clickSum: 0,
      clickLabel: "",
      canDownload: false,
      loading: false,
    };
  },
  computed: {
    showDoorCount: ({ $store: { getters } }) => {
      if(getters.roleCode.indexOf("Coach")>=0||getters.roleCode=='Admin'||this.isAdmin){
        return false
      }
      return true;
    },
    isAdmin: ({ $store: { getters } }) => {
      if (getters.isAdmin + "" === "true") {
        return true;
      } else {
        return false;
      }
    } // 角色是否是admin
  },
  async mounted() {
    await this.getCanDownload()
  },
  methods: {
    onSearch: async function(no) {
      this.subReseller = [];
      // this.searchResult = {
      //   questionnaireCount: 0,
      //   submitCount: 0,
      //   regions: [],
      //   resellers: []
      // };
      this.loading = true;
      let ruleForm = {
        start: this.dateFilter.length == 2 ? this.dateFilter[0] : null,
        end: this.dateFilter.length == 2 ? this.dateFilter[1] : null,
        no: no ? no : null
      };
      let { data } = await window.instance.post(
        openSurveyReqUrl + "statistic",
        ruleForm
      );
      this.searchResult = data.data;
      this.loading = false;
    },
    onReset: function() {
      this.dateFilter = [];
    },
    showDialog: async function(no, count, label) {
      this.subReseller = [];
      let ruleForm = {
        start: this.dateFilter.length == 2 ? this.dateFilter[0] : null,
        end: this.dateFilter.length == 2 ? this.dateFilter[1] : null,
        no: no
      };
      let { data } = await window.instance.post(
        openSurveyReqUrl + "statistic",
        ruleForm
      );
      this.subReseller = data.data.resellers;
      this.clickLabel = label;
      this.clickSum = count;
      this.showFlag = true;
    },
    getCanDownload: async function() {
      let { data } = await window.instance.get(
        openSurveyReqUrl + "account/canViewReport"
      );
      this.canDownload = data.data.result;
    },
    toAllStatistic: function(){
      let query = {}
      if(this.dateFilter){
            query.startTime = this.dateFilter[0];
            query.endTime = this.dateFilter[1];
        }
        this.$router.push({path:"/openSurvey/statisticList",query})
    }
  }
};
</script>
<style scoped lang="scss">
.box-card {
  width: 100%;
  position: relative;

  &.questionnaire-count {
    height: 150px;

    .box-inner-btn{
      position: absolute;
      top: 12px;
      right:20px;
    }
  }

  &.submit-count {
    height: 150px;
  }

  &.region-count {
    height: 480px;
  }

  &.reseller-count {
    height: 480px;
  }

  .title {
    height: 25px;
    font-weight: 500;
  }

  .box-inner {
    position: relative;
    width: 100%;
    text-align: center;
    font-size: 42px;
    font-weight: 600;

    .box-label {
      font-size: 16px;
      font-weight: normal;
    }

    &.box-container {
      position: absolute;
      left: 0;
      width: 100%;
      height: 380px;
      display: inline-flex;
      gap: 10px;
      flex-wrap: wrap;

      .box-item {
        position: relative;

        &.item2 {
          width: calc(50% - 8px);

          .box-label2 {
            position: relative;
            font-size: 16px;
            margin-top: -75px;
            margin-bottom: 55px;
          }
        }

        &.item5 {
          width: calc(20% - 8px);

          .box-label5 {
            position: relative;
            font-size: 16px;
            margin-top: -65px;
            margin-bottom: 45px;
          }
        }
      }
    }
  }
}

.inner-wrapper {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-content: space-around;
  /* 控制多行之间的空间分配 */
  gap: 10px;

  /* 设置子元素之间的间距 */
  .box-card {
    width: calc(50% - 8px);
    position: relative;

    &.questionnaire-count {
      height: 150px;
    }

    &.submit-count {
      height: 150px;
    }

    &.region-count {
      height: 480px;
    }

    &.reseller-count {
      height: 480px;
    }

    .title {
      height: 25px;
      font-weight: 500;
    }

    .box-inner {
      position: relative;
      width: 100%;
      text-align: center;
      font-size: 42px;
      font-weight: 600;

      .box-label {
        font-size: 16px;
        font-weight: normal;
      }

      &.box-container {
        position: absolute;
        left: 0;
        width: 100%;
        height: 380px;
        display: inline-flex;
        gap: 10px;
        flex-wrap: wrap;

        .box-item {
          position: relative;

          &.item2 {
            width: calc(50% - 8px);

            .box-label2 {
              position: relative;
              font-size: 16px;
              margin-top: -75px;
              margin-bottom: 55px;
            }
          }

          &.item5 {
            width: calc(20% - 8px);

            .box-label5 {
              position: relative;
              font-size: 16px;
              margin-top: -65px;
              margin-bottom: 45px;
            }
          }
        }
      }
    }

    .el-date-editor .el-range-separator {
      padding: 0 !important;
      font-size: 12px !important;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/openSurvey/pages/StatisticReport.vue